import React, {useState, useEffect} from 'react'
import {connect, useSelector} from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import {CardBody, Col, Form, FormGroup, Input, Row} from "reactstrap";
import {useForm} from "react-hook-form";

// component
import {setFilter} from "../../../redux/actions/generics/IndexedActions";
import {ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// providers
import {modelsProvider} from "../../../providers/modelsProvider";

// utils
import {utilHelper} from "../../../jwt/_helpers";
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {applicativeProvider} from "../../../providers/applicativeProvider";


const LogHistoryFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter } = componentState?.data || {};

    const [typeAction, setTypeAction] = useState(filter?.item?.action);
    const [model, setModel] = useState(filter?.item?.model);
    const [modelOptions, setModelOptions] = useState([]);
    const [startDate, setStartDate] = useState(filter?.item?.startDate);
    const [endDate, setEndDate] = useState(filter?.item?.endDate);
    const [app, setApp] = useState(filter?.item?.app);

    const {register, handleSubmit, reset} = useForm({});

    useEffect(() => {
        modelsProvider.getOptions()
            .then(result => {
                setModelOptions(result);
            })
            .catch(_ => {
            });

    }, []);

    const onSubmit = (data, _) => {
        const dataFilter = {
            item:{
                id: data.id != "" ? data.id : null,
                userName: data.userName != "" ? data.userName : null,
                model: model?.value,
                action: typeAction?.value,
                startDate: startDate ? utilHelper.dateFormatter(startDate) : null,
                endDate: endDate ? utilHelper.dateFormatter(endDate) : null,
                app:{id:app}
            }
        };

        props.setFilter(path, dataFilter)
    };

    const optionsAction = [
        {id: 'CREATE', value: 'CREATE', label: 'CREATE'},
        {id: 'UPDATE', value: 'UPDATE', label: 'UPDATE'},
        {id: 'DELETE', value: 'DELETE', label: 'DELETE'}
    ];

    const cleanFields = () => {
        reset();
        setModel(null);
        setTypeAction(null);
        setStartDate(null);
        setEndDate(null);
    }

    return <Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Input
                            type="text"
                            name="id"
                            placeholder="id"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Input type="text" name="userName"
                               placeholder="Usuario"
                               innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Select name="model"
                                value={model}
                                options={modelOptions}
                                placeholder="Modelo"
                                isSearchable={true}
                                isClearable={true}
                                onChange={setModel}/>
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Select options={optionsAction}
                                value={typeAction}
                                placeholder="Acción"
                                isClearable={true}
                                onChange={setTypeAction}/>
                    </FormGroup>
                </Col>
                <Col md="3">
                    <SelectGeneric
                        initialValue={app}
                        setExternalValue={setApp}
                        provider={applicativeProvider}
                    />
                </Col>
                <Col md="3">
                    <FormGroup>
                        <DatePicker
                            dateFormat={"dd/MM/yyyy"}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            scrollableYearDropdown={false}
                            startDate={startDate}
                            endDate={endDate}
                            selected={startDate}
                            onChange={date => setStartDate(date)}
                            isClearable
                            placeholderText="Desde"
                            className="form-control"
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <DatePicker
                            dateFormat={"dd/MM/yyyy"}
                            showMonthDropdown={true}
                            showYearDropdown={true}
                            scrollableYearDropdown={false}
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            selected={endDate}
                            onChange={date => setEndDate(date)}
                            isClearable
                            placeholderText="Hasta"
                            className="form-control"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <div className="float-right">
                        <ButtonSearch/>
                        <ButtonClean onClick={() => cleanFields()}/>
                    </div>
                </Col>
            </Row>
        </CardBody>
    </Form>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(LogHistoryFilters)